<template>
  <svg class="a-svg-logo-x9" width="207px" height="207px" viewBox="0 0 207 207">
    <title v-if="cms.heading">{{ cms.heading }}</title>
    <rect :fill="square_1" x="0" y="0" width="69" height="69"></rect>
    <rect :fill="square_2" x="69" y="0" width="69" height="69"></rect>
    <rect :fill="square_3" x="138" y="0" width="69" height="69"></rect>
    <rect :fill="square_4" x="0" y="69" width="69" height="69"></rect>
    <rect :fill="square_5" x="69" y="69" width="69" height="69"></rect>
    <rect :fill="square_6" x="138" y="138" width="69" height="69"></rect>
    <rect :fill="square_7" x="0" y="138" width="69" height="69"></rect>
    <rect :fill="square_8" x="69" y="138" width="69" height="69"></rect>
    <rect :fill="square_9" x="138" y="69" width="69" height="69"></rect>
  </svg>
</template>

<script>
import Colors from '~/mixins/colors'
export default {
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      name: 'a-svg-logo-x9',
    }
  },
  computed: {
    square_1() {
      return this.setColor(
        (this.cms.color_square_1 || {}).color || 'transparent'
      )
    },
    square_2() {
      return this.setColor(
        (this.cms.color_square_2 || {}).color || 'transparent'
      )
    },
    square_3() {
      return this.setColor(
        (this.cms.color_square_3 || {}).color || 'transparent'
      )
    },
    square_4() {
      return this.setColor(
        (this.cms.color_square_4 || {}).color || 'transparent'
      )
    },
    square_5() {
      return this.setColor(
        (this.cms.color_square_5 || {}).color || 'transparent'
      )
    },
    square_6() {
      return this.setColor(
        (this.cms.color_square_6 || {}).color || 'transparent'
      )
    },
    square_7() {
      return this.setColor(
        (this.cms.color_square_7 || {}).color || 'transparent'
      )
    },
    square_8() {
      return this.setColor(
        (this.cms.color_square_8 || {}).color || 'transparent'
      )
    },
    square_9() {
      return this.setColor(
        (this.cms.color_square_9 || {}).color || 'transparent'
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.loader-enter-active,
.loader-leave-active {
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}
.loader-enter,
.loader-leave-active {
  opacity: 0;
}
.a-svg-logo-x9 {
  pointer-events: none;
}
</style>
